import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { ApiLoaderService } from '../../services/api-loader.service';

@Component({
  selector: 'app-api-loader',
  imports: [CommonModule],
  templateUrl: './api-loader.component.html',
  styleUrl: './api-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiLoaderComponent {
  private loaderService = inject(ApiLoaderService);
  show$ = this.loaderService.loaderState.pipe(map((state) => state.show));
}
